<div class="card mt-3">
  <div class="card-body">
    <form [formGroup]="productOptionForm" (ngSubmit)="onProductOptionSubmit()" class="needs-validation form-row">
      <div class="col">
        <div class="form-group" [formGroup]="productOptionForm">
          <label class="control-label col-form-label-sm">{{'price-list.manage.optionName' | translate}}</label>
          <div class="input-group input-group-sm">
            <input type="text" class="form-control {{productOptionErrorArray['name'] ? 'is-invalid' : ''}}"
              placeholder="{{'price-list.manage.productName' | translate}}" name="name" id="name" [required]="true"
              formControlName="name" />
            <div class="input-group-append">
              <span class="input-group-text"> {{(productOptionForm.controls['name'].value ?
                          (productOptionForm.controls['name'].value.length + productOptionForm.controls['extraInfo'].value.length) :
                          0)}} /
                32</span>
            </div>
            <div class="invalid-feedback">
              {{productOptionErrorArray['name'] | translate}}
            </div>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="form-group" [formGroup]="productOptionForm">
          <label class="control-label col-form-label-sm">{{'price-list.manage.extraInfo' | translate}}</label>
          <div class="input-group input-group-sm">
            <input type="text" class="form-control {{productOptionErrorArray['extraInfo'] ? 'is-invalid' : ''}}"
              placeholder="{{'price-list.manage.extraInfo' | translate}}" name="extraInfo" id="extraInfo"
              formControlName="extraInfo">
            <div class="input-group-append">
              <span class="input-group-text"> {{(productOptionForm.controls['name'].value ?
                          (productOptionForm.controls['name'].value.length + productOptionForm.controls['extraInfo'].value.length) :
                          0)}} /
                32</span>
            </div>
            <div class="invalid-feedback">
              {{productOptionErrorArray['extraInfo'] | translate}}
            </div>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="form-group" [formGroup]="productOptionForm">
          <label class="control-label col-form-label-sm">{{'price-list.manage.price' | translate}}</label>
          <div class="input-group input-group-sm">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon1">{{eventCurrency}}</span>
            </div>
            <input type="text" class="form-control {{productOptionErrorArray['price'] ? 'is-invalid' : ''}}"
              placeholder="00.00" name="price" id="price" [required]="true" formControlName="price">
            <div class="invalid-feedback">
              {{productOptionErrorArray['price'] | translate}}
            </div>
          </div>
        </div>
      </div>
      <div class="col-auto text-right">
        <ng-container *ngIf="!editProductOption; else elseTemplate">
          <button type="submit" class="btn btn-primary btn-sm" style="margin-top: 27px;">{{'price-list.manage.add' |
                  translate}}</button>
        </ng-container>
        <ng-template #elseTemplate>
          <button type="submit" class="btn btn-primary btn-sm" style="margin-top: 27px;">{{'price-list.manage.update' |
                    translate}}</button>
          <button type="button" class="btn btn-danger btn-sm" style="margin-top: 27px;" (click)="cancelEditOption()">{{'price-list.manage.cancel' |
                        translate}}</button>
        </ng-template>
      </div>
    </form>

    <div class="table-responsive mt-3">
      <table class="table table-striped table-sm">
        <thead>
          <tr>
            <th scope="col">{{'price-list.manage.name' | translate}}</th>
            <th scope="col">{{'price-list.manage.extraInfo' | translate}}</th>
            <th scope="col">{{'price-list.manage.price' | translate}}</th>
            <th scope="col" class="text-center">{{'price-list.manage.position' | translate}}</th>
            <th scope="col" class="text-center">{{'price-list.manage.displayed' | translate}}</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let option of productOptionsArray; first as isFirst; last as isLast">
            <td>{{option.name}}</td>
            <td>{{option.extraInfo}}</td>
            <td>{{option.price | currency: eventCurrency + ' '}}</td>
            <td class="text-center"><i class="fa fa-arrows-alt-v"></i>{{option.itemOrder}}</td>
            <td class="text-center">
              <ng-container *ngIf="option.status == 1; else disabledTemplate">
                <i style="color: green; cursor: pointer;" class="fas fa-check"
                  (click)="changeProductOptionStatus(option, 0)"></i>
              </ng-container>
              <ng-template #disabledTemplate>
                <i style="color: red; cursor: pointer;" class="fas fa-times"
                  (click)="changeProductOptionStatus(option, 1)"></i>
              </ng-template>
            </td>
            <td class="text-right">
              <div class="btn-group btn-group-sm" role="group" aria-label="Button group with nested dropdown">
                <button type="button" class="btn btn-link" *ngIf="!isFirst" placement="top"
                  [ngbTooltip]="'price-list.manage.moveUp' | translate"
                  (click)="changeProductOptionPosition(option.itemOrder, option.itemOrder-1)"
                  [disabled]="editProductOption"><i class="fa fa-angle-up"></i></button>
                <button type="button" class="btn btn-link" *ngIf="!isLast" placement="top"
                  [ngbTooltip]="'price-list.manage.moveDown' | translate"
                  (click)="changeProductOptionPosition(option.itemOrder, option.itemOrder+1)"
                  [disabled]="editProductOption"><i class="fa fa-angle-down"></i></button>
                <button type="button" class="btn btn-link" placement="top"
                  [ngbTooltip]="'price-list.manage.edit' | translate" (click)="enableProductOptionedit(option)"
                  [disabled]="editProductOption"><i class="fa fa-edit"></i></button>
                <button type="button" class="btn btn-link" placement="top"
                  [ngbTooltip]="'price-list.manage.delete' | translate" (click)="deleteProductOption(option.itemOrder)"
                  [disabled]="editProductOption"><i class="fa fa-trash"></i></button>
                <button type="button" class="btn btn-link" placement="top"
                  [ngbTooltip]="'price-list.manage.duplicate' | translate" (click)="duplicateProductOption(option)"
                  [disabled]="editProductOption"><i class="fa fa-copy"></i></button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="card-footer">
    <button class="btn btn-primary btn-sm float-right" type="button" [disabled]="disableSaveButton" (click)="saveOptionsToProducts()">
      <i class="fa fa-save"></i> <br />
      Save
    </button>
  </div>
</div>
